import axiosInstance from "../api/axiosInstance";
import API_ENDPOINTS from "../api/endpoints";

const PayrollService = {
  getBatchHistory: (params) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL_PAYMENT.BATCH_HISTORY, {
      params,
    }),

  getEmployeeBatchHistory: (params) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL_PAYMENT.EMPLOYEE_BATCH_HISTORY, {
      params,
    }),

  getPendingPayrollPayments: (params) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL.PAYROLL_PENDING_PAYMENY, {
      params
    }),

  exportPayrollHistoryCSV: (params) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL_PAYMENT.EXPORT_DAILY_CSV, {
      params,
      responseType: "blob",
    }),

  getEmployeesPayrollDetails: (params) =>
    axiosInstance.get(
      API_ENDPOINTS.PAYROLL.GET_EMPLOYEES_PAYROLL_DETAILS,
      { params }
    ),

  generatePayCheck: (employeeId) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL.GENERATE_PAYCHECK(employeeId), {
      responseType: "blob",
    }),

  payrollDashboard: (params) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL.DASHBOARD, {
      params,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== null && value !== undefined && value !== "") {
            searchParams.append(key, value);
          }
        });

        return searchParams.toString();
      },
    }),

  runPayrollCalulation: (params) => {
    return axiosInstance.post(
      API_ENDPOINTS.PAYROLL.CALCULATE,
      null,
      {
        params: {
          companyId: params.companyId,
          payrollFrom: params.payrollFrom,
          payrollTo: params.payrollTo,
          cycleType: params.cycleType,
        },
      }
    );
  },

  exportPayrollExcelAsync: (headerId) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL.EXPORT(headerId), {
      responseType: "blob",
    }),

  updateEmployeesWorkDetails: (headerId, dto) =>
    axiosInstance.put(
      API_ENDPOINTS.PAYROLL.UPDATE_EMPLOYEES_WORK_DETAILS(headerId),
      { PayrollHeaderId: headerId, Employees: dto },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    ),

  paymentDirectDeposit: (payrollHeaderId) =>
    axiosInstance.post(
      API_ENDPOINTS.PAYROLL_PAYMENT.PROCESS_DIRECT_DEPOSIT(payrollHeaderId),
      {},  // Pass empty object instead of null as request body
      {
        timeout: 60000, // 60 seconds timeout for direct deposit processing
      }
    ),

  payTax: (request, userId) =>
    axiosInstance.post(API_ENDPOINTS.PAYROLL_PAYMENT.PAY_TAX, request, {
      params: { userId },
    }),

  getTaxStatus: (params) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL_PAYMENT.TAX_STATUS, {
      params,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== null && value !== undefined && value !== "") {
            searchParams.append(key, value);
          }
        });

        return searchParams.toString();
      },
    }),

  exportTaxCSV: (params) =>
    axiosInstance.get(API_ENDPOINTS.PAYROLL_PAYMENT.TAX_EXPORT, {
      params,
      responseType: "blob",
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== null && value !== undefined && value !== "") {
            searchParams.append(key, value);
          }
        });

        return searchParams.toString();
      },
    }),

};

export default PayrollService;
